var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import Button from '@doordash/component-button';
import { Icon, Stack, StackChildren, Text } from '@doordash/design-language';
import styled from 'styled-components';
import { EXTERNAL_ROUTES, IMAGE_BASE_URL } from '../../../../constants/values';
import EmOnboardingStrings from '../EmOnboardingStrings';
import track from '../../../../utils/track';
import { OnboardingEvents } from '../../../../constants/events';
import { SetupOptionId } from '../EmOnboardingPageData';
var strings = EmOnboardingStrings.quickStart;
var quickStartSuccessImageUrl = IMAGE_BASE_URL + "/s/managed/consumer/teams/celebrate.png";
var actions = {
    startOrder: 'Start Order',
    manageEmployees: 'Manage Employees',
    faq: 'View Faq',
    support: 'View Support',
};
var QuickStartSuccessContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 90%;\n"], ["\n  width: 90%;\n"])));
var StyledImage = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 40%;\n"], ["\n  width: 40%;\n"])));
var LinkText = styled(Text).attrs(function () { return ({
    color: Text.Colors.TextSecondary,
    textDecoration: Text.TextDecorations.Underline,
    display: Text.DisplayModes.Inline,
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export var QuickStartSuccess = function (_a) {
    var onStartOrderClick = _a.onStartOrderClick, onManageEmployeesClick = _a.onManageEmployeesClick;
    React.useEffect(function () {
        track(OnboardingEvents.SUCCESS_PAGE_VIEW, {
            setup: SetupOptionId.quickStart,
        });
    }, []);
    return (React.createElement(QuickStartSuccessContainer, null,
        React.createElement(Stack, null,
            React.createElement(StyledImage, { src: quickStartSuccessImageUrl, alt: 'quick-start-success-img' })),
        React.createElement(Stack, { size: Stack.Sizes.XxxLarge },
            React.createElement(StackChildren, null,
                React.createElement(Text, { styles: Text.Styles.PageTitle1 }, strings.success.title()),
                React.createElement(Text, { styles: Text.Styles.Medium16, color: Text.Colors.TextSecondary }, strings.success.description()),
                React.createElement(Button, { onClick: function () {
                        track(OnboardingEvents.ACTIONS_CLICK, {
                            action: actions.startOrder,
                        });
                        onStartOrderClick();
                    }, children: strings.startOrder(), trailingIcon: Icon.Types.ArrowUpRight, isInline: true }))),
        React.createElement(Stack, { size: Stack.Sizes.XxxLarge },
            React.createElement(StackChildren, null,
                React.createElement(Text, { styles: Text.Styles.Title2 }, strings.needToInviteMoreMembers.title()),
                React.createElement(Text, { styles: Text.Styles.Medium16, color: Text.Colors.TextSecondary }, strings.needToInviteMoreMembers.description()),
                React.createElement(Button, { onClick: function () {
                        track(OnboardingEvents.ACTIONS_CLICK, {
                            action: actions.manageEmployees,
                        });
                        onManageEmployeesClick();
                    }, children: strings.manageEmployees(), type: Button.Types.Tertiary, isInline: true }))),
        React.createElement(Stack, null,
            React.createElement(StackChildren, null,
                React.createElement(Text, { styles: Text.Styles.Title2 }, strings.stillHaveQuestions.title()),
                React.createElement(Text, { color: Text.Colors.TextSecondary },
                    "You can learn more at our",
                    ' ',
                    React.createElement("a", { href: EXTERNAL_ROUTES.WORK_FAQ, target: "_blank", rel: "noopener noreferrer", onClick: function () {
                            track(OnboardingEvents.ACTIONS_CLICK, { action: actions.faq });
                        } },
                        React.createElement(LinkText, { children: 'Frequently Asked Questions' })),
                    ' ',
                    "or contact",
                    ' ',
                    React.createElement("a", { href: EXTERNAL_ROUTES.WORK_SUPPORT, target: "_blank", rel: "noopener noreferrer", onClick: function () {
                            track(OnboardingEvents.ACTIONS_CLICK, {
                                action: actions.support,
                            });
                        } },
                        React.createElement(LinkText, { children: 'DoorDash for Work support' })),
                    ".")))));
};
var templateObject_1, templateObject_2, templateObject_3;
